// removed by extract-text-webpack-plugin
module.exports = {"resorts":"_3bSv","scroller":"_3AAA","item":"_2Y_p","slide":"_2p5d","innerSlide":"SJH3","img":"n5y4","itemTitle":"_1-SR","blurb":"_33rr","price":"_3-23","goto":"QAXd","gold":"_3PWL","turquoise":"_3SWZ","textGold":"ZnZY","iconDiamond":"xXjv","textTurquoise":"_3LX8","subtitle":"KKJN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/resorts/scrollingresorts/style.css
// module id = 370
// module chunks = 9